import React, { useState } from 'react';
import { CheckIcon, LockIcon, CreditCardIcon, ArrowRightIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  const [selectedPack, setSelectedPack] = useState<'basic' | 'premium'>('premium');
  const basicLink = 'https://mi-tienda-2-8952.myshopify.com/cart/51610834501952:1';
  const premiumLink = 'https://mi-tienda-2-8952.myshopify.com/cart/51610836238656:1';
  const economiaLink = 'https://mi-tienda-2-8952.myshopify.com/cart/51614142923072:1';
  const contabilidadLink = 'https://mi-tienda-2-8952.myshopify.com/cart/51614153310528:1';
  const getCheckoutLink = () => {
    if (selectedPack === 'basic') return basicLink;
    return premiumLink;
  };
  return <section id="pricing" className="bg-[#0a0e27] py-4 md:py-6 px-4 font-sans" data-id="element-297">
      <div className="max-w-5xl mx-auto" data-id="element-298">
        <h2 className="text-3xl md:text-5xl font-extrabold text-white text-center italic mb-4" data-id="element-299">
          Elegí tu Pack Completo
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 max-w-4xl mx-auto mb-4" data-id="element-300">
          {/* Basic Pack */}
          <div onClick={() => setSelectedPack('basic')} className={`relative bg-[#111638] rounded-lg p-2 pt-2.5 text-center cursor-pointer transition-all duration-300 border-2 ${selectedPack === 'basic' ? 'border-[#22c55e] shadow-[0_0_20px_rgba(34,197,94,0.15)]' : 'border-gray-800 hover:border-gray-700'}`} data-id="element-301">
            <div className="absolute top-1.5 right-1.5" data-id="element-302">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selectedPack === 'basic' ? 'border-[#22c55e] bg-[#22c55e]' : 'border-gray-600'}`} data-id="element-303">
                {selectedPack === 'basic' && <CheckIcon className="w-3 h-3 text-white" strokeWidth={3} data-id="element-304" />}
              </div>
            </div>
            <h3 className="text-xl font-bold text-white italic mb-0" data-id="element-305">
              KIT COMPLETO
            </h3>
            <p className="text-gray-400 text-xs mb-0.5" data-id="element-306">
              Para Docentes de Secundaria Argentina
            </p>
            <p className="text-gray-500 text-[10px] mb-0.5" data-id="element-307">
              6 Tomos + 4 Bonus
            </p>
            <div className="text-4xl font-black text-white tracking-tight leading-none" data-id="element-308">
              $19.990
            </div>
            <div className="text-gray-500 line-through text-sm font-medium decoration-red-500/50 decoration-2" data-id="element-309">
              $39.990
            </div>
          </div>

          {/* Premium Pack */}
          <div onClick={() => setSelectedPack('premium')} className={`relative bg-[#111638] rounded-lg p-2 pt-2.5 text-center cursor-pointer transition-all duration-300 border-2 ${selectedPack === 'premium' ? 'border-[#22c55e] shadow-[0_0_20px_rgba(34,197,94,0.15)]' : 'border-gray-800 hover:border-gray-700'}`} data-id="element-310">
            <div className="absolute -top-2.5 left-1/2 transform -translate-x-1/2 bg-[#22c55e] text-white text-[10px] font-bold px-2.5 py-0.5 rounded-full flex items-center gap-1 shadow-lg whitespace-nowrap" data-id="element-311">
              ⭐ Más elegido
            </div>
            <div className="absolute top-1.5 right-1.5" data-id="element-312">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selectedPack === 'premium' ? 'border-[#22c55e] bg-[#22c55e]' : 'border-gray-600'}`} data-id="element-313">
                {selectedPack === 'premium' && <CheckIcon className="w-3 h-3 text-white" strokeWidth={3} data-id="element-314" />}
              </div>
            </div>
            <h3 className="text-xl font-bold text-white italic mb-0" data-id="element-315">
              PACK PREMIUM
            </h3>
            <p className="text-gray-400 text-xs mb-0.5" data-id="element-316">
              Kit Completo + Proyecto Argentina 2026
            </p>
            <p className="text-gray-500 text-[10px] mb-0.5" data-id="element-317">
              6 Tomos + 4 Bonus + Inmersión Total
            </p>
            <div className="text-4xl font-black text-white tracking-tight leading-none" data-id="element-318">
              $27.990
            </div>
            <div className="text-gray-500 line-through text-sm font-medium decoration-red-500/50 decoration-2" data-id="element-319">
              $49.990
            </div>
          </div>
        </div>

        {/* NEW: Pack Secundaria Completa Offers */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 max-w-4xl mx-auto mb-4" data-id="element-320">
          {/* Economia Pack */}
          <a href={economiaLink} target="_blank" rel="noopener noreferrer" className="block relative bg-gradient-to-br from-[#111638] to-[#0d1230] rounded-xl p-5 text-center transition-all duration-300 border-2 border-[#22c55e] shadow-[0_0_25px_rgba(34,197,94,0.15)] hover:shadow-[0_0_35px_rgba(34,197,94,0.25)] hover:scale-[1.02] no-underline group" data-id="element-321">
            <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-[#22c55e] text-white text-[10px] font-bold px-3 py-0.5 rounded-full shadow-lg whitespace-nowrap uppercase tracking-wider" data-id="element-322">
              🔥 Oferta Especial
            </div>
            <h3 className="text-lg md:text-xl font-extrabold text-white italic mb-1 mt-1 uppercase tracking-wide" data-id="element-323">
              Pack Secundaria Completa
            </h3>
            <p className="text-[#22c55e] text-sm md:text-base font-bold mb-1" data-id="element-324">
              Kit Educación Financiera + Economía Lista
            </p>
            <p className="text-gray-400 text-xs md:text-sm mb-1 font-medium" data-id="element-325">
              📚 10 Tomos + 7 Bonus
            </p>
          </a>

          {/* Contabilidad Pack */}
          <a href={contabilidadLink} target="_blank" rel="noopener noreferrer" className="block relative bg-gradient-to-br from-[#111638] to-[#0d1230] rounded-xl p-5 text-center transition-all duration-300 border-2 border-[#22c55e] shadow-[0_0_25px_rgba(34,197,94,0.15)] hover:shadow-[0_0_35px_rgba(34,197,94,0.25)] hover:scale-[1.02] no-underline group" data-id="element-326">
            <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-[#22c55e] text-white text-[10px] font-bold px-3 py-0.5 rounded-full shadow-lg whitespace-nowrap uppercase tracking-wider" data-id="element-327">
              🔥 Oferta Especial
            </div>
            <h3 className="text-lg md:text-xl font-extrabold text-white italic mb-1 mt-1 uppercase tracking-wide" data-id="element-328">
              Pack Secundaria Completa
            </h3>
            <p className="text-[#22c55e] text-sm md:text-base font-bold mb-1" data-id="element-329">
              Kit Educación Financiera + Contabilidad Lista
            </p>
            <p className="text-gray-400 text-xs md:text-sm mb-1 font-medium" data-id="element-330">
              📚 10 Tomos + 7 Bonus
            </p>
          </a>
        </div>

        {/* CTA for Pack Secundaria Completa */}
        <div className="text-center mb-4" data-id="element-331">
          <CTAButton href={contabilidadLink} className="w-full max-w-md py-3 text-xl italic shadow-[0_0_20px_rgba(34,197,94,0.3)] mb-1.5" data-id="element-332">
            Sí, quiero mi pack →
          </CTAButton>
          <div className="flex items-center justify-center gap-2 text-gray-500 text-xs font-medium uppercase tracking-wider" data-id="element-333">
            <LockIcon className="w-3 h-3" data-id="element-334" /> Pago seguro con Mercado Pago
          </div>
        </div>

        {/* Pack Includes */}
        <div className="max-w-2xl mx-auto bg-[#111638] border border-gray-800 rounded-lg p-3 md:p-4 mb-3 shadow-xl" data-id="element-335">
          <h4 className="text-white font-bold text-center mb-2 uppercase tracking-wide flex items-center justify-center gap-2" data-id="element-336">
            👑 PACK COMPLETO INCLUYE:
          </h4>
          <ul className="space-y-1.5" data-id="element-337">
            <li className="flex items-start gap-2" data-id="element-338">
              <div className="bg-[#22c55e] rounded flex-shrink-0 mt-0.5 w-4 h-4 flex items-center justify-center" data-id="element-339">
                <CheckIcon className="w-3 h-3 text-white" strokeWidth={4} data-id="element-340" />
              </div>
              <span className="text-gray-300 text-sm md:text-base" data-id="element-341">
                Kit completo de Educación Financiera para secundaria
              </span>
            </li>
            <li className="flex items-start gap-2" data-id="element-342">
              <div className="bg-[#22c55e] rounded flex-shrink-0 mt-0.5 w-4 h-4 flex items-center justify-center" data-id="element-343">
                <CheckIcon className="w-3 h-3 text-white" strokeWidth={4} data-id="element-344" />
              </div>
              <span className="text-gray-300 text-sm md:text-base" data-id="element-345">
                10 tomos con secuencias didácticas completas
              </span>
            </li>
            <li className="flex items-start gap-2" data-id="element-346">
              <div className="bg-[#22c55e] rounded flex-shrink-0 mt-0.5 w-4 h-4 flex items-center justify-center" data-id="element-347">
                <CheckIcon className="w-3 h-3 text-white" strokeWidth={4} data-id="element-348" />
              </div>
              <span className="text-gray-300 text-sm md:text-base" data-id="element-349">
                7 BONUS incluidos
              </span>
            </li>
            <li className="flex items-start gap-2" data-id="element-350">
              <div className="bg-[#22c55e] rounded flex-shrink-0 mt-0.5 w-4 h-4 flex items-center justify-center" data-id="element-351">
                <CheckIcon className="w-3 h-3 text-white" strokeWidth={4} data-id="element-352" />
              </div>
              <span className="text-gray-300 text-sm md:text-base" data-id="element-353">
                Entrega inmediata (PDF)
              </span>
            </li>
            <li className="flex items-start gap-2" data-id="element-354">
              <div className="bg-[#22c55e] rounded flex-shrink-0 mt-0.5 w-4 h-4 flex items-center justify-center" data-id="element-355">
                <CheckIcon className="w-3 h-3 text-white" strokeWidth={4} data-id="element-356" />
              </div>
              <span className="text-gray-300 text-sm md:text-base" data-id="element-357">
                Acceso de por vida
              </span>
            </li>
            <li className="flex items-start gap-2" data-id="element-358">
              <div className="bg-[#22c55e] rounded flex-shrink-0 mt-0.5 w-4 h-4 flex items-center justify-center" data-id="element-359">
                <CheckIcon className="w-3 h-3 text-white" strokeWidth={4} data-id="element-360" />
              </div>
              <span className="text-gray-300 text-sm md:text-base" data-id="element-361">
                Garantía de satisfacción de 7 días
              </span>
            </li>
            <li className="flex items-start gap-2" data-id="element-362">
              <div className="bg-[#22c55e] rounded flex-shrink-0 mt-0.5 w-4 h-4 flex items-center justify-center" data-id="element-363">
                <CheckIcon className="w-3 h-3 text-white" strokeWidth={4} data-id="element-364" />
              </div>
              <span className="text-gray-300 text-sm md:text-base" data-id="element-365">
                Alineado NAP 2026
              </span>
            </li>
          </ul>
        </div>

        {/* Payment Methods */}
        <div className="flex justify-center" data-id="element-366">
          <div className="inline-flex items-center gap-2 border border-gray-800 rounded-full px-4 py-1.5 text-gray-500 text-xs md:text-sm" data-id="element-367">
            <CreditCardIcon className="w-3.5 h-3.5" data-id="element-368" />
            <span data-id="element-369">Transferencia · Mercado Pago · Tarjeta</span>
          </div>
        </div>
      </div>
    </section>;
}